import React, { JSX } from 'react';
import { Select } from '@/components';
import { OptionProps } from '@/components/Select';
import Payment from '@/model/Payment';
import { calculateCreditCardPaymentValue } from '@/helpers/payment/installmentFees';
import { CardCheckout } from '../types';

interface StateProps {
  payment: Payment;
  totalValue: number;
  card: CardCheckout;
}

interface DispatchProps {
  toCurrency: (value: number) => string;
  onChange: (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => void;
}

type Props = StateProps & DispatchProps;

export const CreditCardC6PaymentRequestContent: React.FC<Props> = ({
  payment,
  totalValue,
  toCurrency,
  onChange,
  card,
}): JSX.Element => {
  const options: OptionProps[] = [];

  if (payment && payment.fees && payment.fees.installmentFees.length > 0) {
    if (totalValue > 0) {
      payment.fees.installmentFees.forEach(({ installment, fee }) => {
        const value = calculateCreditCardPaymentValue(
          totalValue,
          payment.fees.credit,
          fee,
          installment,
        );
        const option: OptionProps = {
          value: installment,
          label: `${installment} X ${toCurrency(value / installment)}`,
        };
        options.push(option);
      });
    }
  }
  return (
    <div className="w-full md:w-[411px] mt-[14px]">
      <div className="flex flex-col justify-between">
        <div className="space-y-5 ">
          <div>
            <div className="mb-[20px]">
              <div className="block mt-[20px] mb-[20px]">
                <div className="mb-[20px]">
                  <Select
                    name="installments"
                    label="Parcelamento"
                    placeholder="Escolha a quantidade de parcelas"
                    className={`appearance-none w-full
              rounded-md text-heading leading-tight focus:outline-none
              focus:shadow-outline text-xs font-dmsans font-normal`}
                    maxLength={18}
                    value={card.installments}
                    onChange={e => onChange(e)}
                    options={options}
                    error={card.installmentsError}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
